import bgImage from "images/new/bg-homepage-bottom.jpg";
import arrow from "images/new/icons/arrow.svg";
import React from "react";

interface BottomCTAProps {
  className?: string;
  title?: string;
  buttonText?: string;
  buttonLink?: string;
}

const BottomCTA: React.FC<BottomCTAProps> = ({ className = "", title = "Breaking Barriers, Building Payment Bridges", buttonText = "Apply Now", buttonLink = "/contact" }) => {
  return (
    <section
      className={`relative w-full min-h-[300px] md:min-h-[400px] flex items-center ${className}`}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent" />

      {/* Content */}
      <div className="container relative z-10">
        <div className="max-w-2xl flex flex-col items-center justify-center mx-auto">
          <h2 className="text-2xl md:text-5xl text-center font-semibold text-white mb-8 ">
            Breaking Barriers,
            <span className="pt-1 md:pt-4 block">Building Payment Bridges</span>
          </h2>

          <a href="/sign-up" className="inline-flex items-center justify-between gap-2 bg-white text-black px-2 pl-8 py-2 rounded-full font-medium hover:bg-gray-100 transition-colors">
            Apply Now
            <div className="w-12 h-12 rounded-full bg-[#7F84F6] hover:bg-[#7F84F6]/80 flex items-center justify-center ml-2">
              <img src={arrow} alt="" className="w-6 h-6" />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BottomCTA;
